import { FileLoader } from "./FileLoader";
/**
 * Our implementation of loading textures from remote endpoints.
 */
export class ImageLoader {
    static load(url, options) {
        return new Promise((resolve, reject) => {
            // Construct an image element to create our image with
            const image = document.createElementNS("http://www.w3.org/1999/xhtml", "img");
            // This event will trigger our promise resolve, once the image is loaded
            image.onload = () => {
                image.onload = null;
                URL.revokeObjectURL(image.src);
                resolve(image);
            };
            // If any loading errors occur we reject the promise
            image.onerror = (ev) => {
                reject();
            };
            // Perform the file load and write it to image.src to start the image load
            FileLoader.loadBlob(url, options).then((value) => {
                image.src = URL.createObjectURL(value);
            }, reject);
        });
    }
}
